import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";

import InternetIcon from "../../../Components/Icon-SVG/InternetIcon";
import AnalyserIcon from "../../../Components/Icon-SVG/AnalyserIcon";
import TableSpinnerIcon from "../../../Components/Icon-SVG/TableSpinnerIcon";

import { TriggerPhishboxHealthCheck } from "../../../store/actions/healthCheckActions";

const ICON_SIZE = {
  width: 20,
  height: 20,
};

const SERVICES = [
  {
    id: "internet",
    header: "Internet",
    stateKey: "phishboxInternetStatus",
    renderIcon: (color, width, height) => (
      <InternetIcon color={color} width={width} height={height} />
    ),
  },
  {
    id: "broker",
    header: "Backend",
    stateKey: "brokerStatus",
    renderIcon: (color, width, height) => (
      <AnalyserIcon color={color} width={width} height={height} />
    ),
  },
  {
    id: "phish",
    header: "PhishBox",
    stateKey: "phishStatus",
    renderIcon: (color, width, height) => (
      <InternetIcon color={color} width={width} height={height} />
    ),
  },
];

const PhishBoxHealth = () => {
  const dispatch = useDispatch();

  const healthState = useSelector((state) => state.healthCheck);
  const { phishboxHealthLoading } = healthState;

  useEffect(() => {
    dispatch(TriggerPhishboxHealthCheck());
  }, [dispatch]);

  const refreshHandler = () => {
    dispatch(TriggerPhishboxHealthCheck());
  };

  return (
    <div className="phishbox__services">
      <div className="phishbox__services__header">
        <h2 className="phishbox__services__header__heading">Services</h2>
        <div className="phishbox__services__header__refresh" onClick={refreshHandler}>
          <TableSpinnerIcon
            className="phishbox__services__spinner"
            customStyle={{ margin: "0", height: "20px" }}
            spin={phishboxHealthLoading}
          />
        </div>
      </div>
      {SERVICES.map((service) => (
        <div className="phishbox__services__block border" key={service.id}>
          <div className="phishbox__services__block--icon">
            {service.renderIcon("white", ICON_SIZE.width, ICON_SIZE.height)}
          </div>
          <p className="phishbox__services__block--text" style={{ color: "white" }}>
            {service.header}
          </p>
          <div className="phishbox__services__block--signal">
            <b
              className={`phishbox__services__block--signal--status ${healthState[service.stateKey] ? "open" : "close"}`}></b>
          </div>
        </div>
      ))}
    </div>
  );
};

export default PhishBoxHealth;
